import Course from "../models/Course";
import "svelte-i18n";
export default class CourseService {
    mapInterfaceToModel(input, repositories) {
        let course = new Course();
        course.id = parseInt(input.id);
        course.subject = repositories[0].get(input.subject_id);
        course.code = input.code;
        course.name = input.name;
        let timetableArray = [];
        let timetableIds = [];
        input.timetables.forEach(timetableId => {
            timetableIds.push(parseInt(timetableId));
            timetableArray.push(repositories[1].get(timetableId));
        });
        course.timetables = timetableArray;
        course.timetableIDS = timetableIds;
        let tutorsArray = [];
        let tutorIds = [];
        input.tutors.forEach(tutorId => {
            tutorIds.push(parseInt(tutorId));
            tutorsArray.push(repositories[2].get(tutorId));
        });
        course.tutors = tutorsArray;
        course.tutorIDs = tutorIds;
        course.type = input.type;
        return course;
    }
}
